import { RepositoryFactory } from "repositories/factory";
import {
  AscmuMonitoringSetting,
} from "models/ascmu-monitoring-setting";
import {
  AscmuMonitoringSettingsRepositoryError,
} from "repositories/modules/ascmu-monitoring-settings";

const AscmuMonitoringSettingsRepository = RepositoryFactory.get("ascmu-monitoring-settings");
const MonitoringDevicesRepository = RepositoryFactory.get("monitoring-devices");

/* フォームアイテム */
class AscmuMonitoringSettingsController {
  constructor() {
    this._ascmuMonitoringSetting = null;
    this._previousMonitoringDevice = null;
    this._currentMonitoringDevice = null;
  }

  get ascmuMonitoringSetting() {
    return this._ascmuMonitoringSetting;
  }

  set ascmuMonitoringSetting(value) {
    this._ascmuMonitoringSetting = value;
  }

  get previousMonitoringDevice() {
    return this._previousMonitoringDevice;
  }

  set previousMonitoringDevice(value) {
    this._previousMonitoringDevice = value;
  }

  get currentMonitoringDevice() {
    return this._currentMonitoringDevice;
  }

  set currentMonitoringDevice(value) {
    this._currentMonitoringDevice = value;
  }

  /* 算出プロパティ */
  isDelete() {
    // 古い監視設定の削除条件
    return !!this.ascmuMonitoringSetting && (
      !this.currentMonitoringDevice
      || this.ascmuMonitoringSetting.monitoringDeviceId
        !== this.currentMonitoringDevice.monitoringDeviceId
    );
  }

  isStore() {
    let currentMonitoringDeviceId = null;
    if (this.currentMonitoringDevice) {
      currentMonitoringDeviceId = this.currentMonitoringDevice.monitoringDeviceId;
    }
    let previousMonitoringDeviceId = null;
    if (this.previousMonitoringDevice) {
      previousMonitoringDeviceId = this.previousMonitoringDevice.monitoringDeviceId;
    }

    return currentMonitoringDeviceId
      && previousMonitoringDeviceId !== currentMonitoringDeviceId;
  }

  isMonitoringDeviceSelected() {
    return !!this.currentMonitoringDevice;
  }

  /* イベントハンドラ */
  updateCurrentMonitoringDevice(monitoringDevice) {
    // 監視デバイスの選択
    this.currentMonitoringDevice = monitoringDevice;
  }

  clearCurrentMonitoringDevice() {
    // 現在選択中の監視デバイスをクリア
    this.currentMonitoringDevice = null;
  }

  getCurrentMonitoringDeviceId() {
    let res = null;
    if (this.currentMonitoringDevice) {
      res = this.currentMonitoringDevice.monitoringDeviceId;
    }
    return res;
  }

  async getAvaiableList(projectId) {
    const monitoringDevices = await MonitoringDevicesRepository.getAvaiableList(
      projectId,
    );
    if (
      this.previousMonitoringDevice
      && this.previousMonitoringDevice !== this.currentMonitoringDevice) {
      monitoringDevices.push(this.previousMonitoringDevice);
    }
    return monitoringDevices;
  }

  /* 初期化・登録処理 */
  static async createInstance(monitoringTargetId = null) {
    // 初期化(DBの値をフォーム反映)
    const ascmuMonitoringSettingsController = new AscmuMonitoringSettingsController();
    if (!monitoringTargetId) {
      // monitoringTargetIdがnull(=新しい監視対象)の場合は、新しいインスタンスをそのまま帰す
      return ascmuMonitoringSettingsController;
    }
    // 監視対象がDB上に存在する場合はその設定情報を取得する
    const ascmuMonitoringSettings = await AscmuMonitoringSettingsRepository.index(
      monitoringTargetId,
    );

    if (ascmuMonitoringSettings.length === 0) {
      // データが存在しなければ、新規インスタンスをそのまま帰す
      return ascmuMonitoringSettingsController;
    }
    if (ascmuMonitoringSettings.length > 1) {
      // 1つ以上のデータが存在する場合は、データ不整合が発生しているため、例外を返す
      // TODO: 専用のカスタム例外を返す
      throw new AscmuMonitoringSettingsRepositoryError();
    }

    // DBの値をセット
    [ascmuMonitoringSettingsController.ascmuMonitoringSetting] = ascmuMonitoringSettings;
    console.log(this.ascmuMonitoringSetting);
    // 監視デバイス情報を取得
    //　監視対象が存在しない場合は、例外が送出される
    ascmuMonitoringSettingsController.currentMonitoringDevice
      = await MonitoringDevicesRepository.get(
        ascmuMonitoringSettingsController.ascmuMonitoringSetting.projectId,
        ascmuMonitoringSettingsController.ascmuMonitoringSetting.monitoringDeviceId,
      );
    ascmuMonitoringSettingsController.previousMonitoringDevice
       = ascmuMonitoringSettingsController.currentMonitoringDevice.copy();

    return ascmuMonitoringSettingsController;
  }

  // 登録/更新
  async deleteAscmuMonitoringSetting() {
    if (this.isDelete()) {
      await AscmuMonitoringSettingsRepository.destroy(
        this.ascmuMonitoringSetting.monitoringTargetId,
        this.ascmuMonitoringSetting.monitoringSettingId,
      );
      this.ascmuMonitoringSetting = null;
      this.previousMonitoringDevice = null;
    }
  }

  async storeAscmuMonitoringSetting(monitoringTargetId) {
    if (this.isStore() && !!this.ascmuMonitoringSetting) {
      // 通常発生しない状態のためエラーを送付する
      throw new AscmuMonitoringSettingsRepositoryError();
    } else if (this.isStore()) {
      const ascmuMonitoringSetting = new AscmuMonitoringSetting(monitoringTargetId);
      ascmuMonitoringSetting.monitoringDeviceId
        = this.currentMonitoringDevice.monitoringDeviceId;
      ascmuMonitoringSetting.organizationId
        = this.currentMonitoringDevice.organizationId;
      ascmuMonitoringSetting.projectId
        = this.currentMonitoringDevice.projectId;
      this.ascmuMonitoringSetting = await AscmuMonitoringSettingsRepository.store(
        ascmuMonitoringSetting,
      );
      this.previousMonitoringDevice = this.currentMonitoringDevice;
    }
  }
}

export {
  AscmuMonitoringSettingsController,
};
